import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography, IconButton, Chip } from "@mui/material";
import styles from "./style";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../../components/CustomPagination";
import { ReactComponent as EditIcon } from "../../../../assets/AccountingModule/edit.svg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SettingsIcon from "@mui/icons-material/Settings";

const LeaveBalanceList = ({ data, page, setPage, total, handleEdit, handleManage, handleDelete, canEdit, selectedLeaveType }) => {
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getStatusChipStyles = (status) => {
    if (!status) {
      return {
        backgroundColor: "default",
        color: "inherit"
      };
    }
    const statusLower = status.toLowerCase();
    if (statusLower === "active" || statusLower === "approved") {
      return {
        backgroundColor: "#cef5d6",
        color: "#126300"
      };
    }
    if (statusLower === "pending") {
      return {
        backgroundColor: "#fff3cd",
        color: "#856404"
      };
    }
    if (statusLower === "closed" || statusLower === "rejected") {
      return {
        backgroundColor: "#f5f5f5",
        color: "#666"
      };
    }
    return {
      backgroundColor: "default",
      color: "inherit"
    };
  };

  const handleNavigate = (item) => {
    const viewData = {
      _id: item._id || item.id,
      fullName: `${item.employee?.personalInfo?.firstName || ""} ${item.employee?.personalInfo?.surName || ""}`.trim(),
      image: item.employee?.personalInfo?.image || "",
      employee: item.employee,
      leaveType: item.leaveType || "-",
      leaveFrom: item.leaveFrom || null,
      leaveTo: item.leaveTo || null,
      noOfDays: item.noOfDays || item.used || "-",
      dateReq: item.dateReq || item.createdAt || null,
      status: item.status || "Pending",
      reason: item.reason || "-",
      accrued: item.accrued,
      used: item.used,
      balance: item.balance,
    };
    navigate("/dashboard/viewLeaveManagement", { state: { item: viewData } });
  };

  const getBalanceData = () => {
    if (data && data.length > 0) {
      return data.map((item) => ({
        ...item,
        employee: item.employee,
        leaveType: item.leaveType || "-",
        accrued: item.accruedBalance ?? "-",
        used: item.used ?? "-",
        balance: item.balance ?? "-",
        id: item._id || item.id,
      }));
    }
    return [];
  };

  const balanceData = getBalanceData();

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Employee</TableCell>
              <TableCell sx={styles.TableHead}>Leave Type</TableCell>
              {selectedLeaveType ? (
                <>
                  <TableCell sx={styles.TableHead}>Accrued</TableCell>
                  <TableCell sx={styles.TableHead}>Used</TableCell>
                  <TableCell sx={styles.TableHead}>Balance</TableCell>
                </>
              ) : (
                <>
                  <TableCell sx={styles.TableHead}>Leave From</TableCell>
                  <TableCell sx={styles.TableHead}>Leave To</TableCell>
                  <TableCell sx={styles.TableHead}>Status</TableCell>
                  <TableCell sx={styles.TableHead}>No Of Days</TableCell>
                </>
              )}
              <TableCell sx={styles.TableHead}>Actions</TableCell> 
            </TableRow>
          </TableHead>
          <TableBody>
            {balanceData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              balanceData.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tableAvtardata} onClick={() => item.employee && handleNavigate(item)}>
                    {item.employee?.personalInfo?.image ? (
                      <Avatar src={item.employee.personalInfo.image} sx={{ mr: "8px" }} />
                    ) : (
                      <Avatar sx={{ mr: "8px", bgcolor: "#28AA4A" }}>
                        {item.employee?.personalInfo?.firstName?.[0] || "E"}
                      </Avatar>
                    )}
                    <Box>
                      <Typography sx={styles.name}>
                        {item.employee?.personalInfo?.firstName || "Employee"} {item.employee?.personalInfo?.surName || ""}
                      </Typography>
                      {item.employee?.personalInfo?.email && (
                        <Typography sx={styles.mail}>{item.employee.personalInfo.email}</Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tabledata}>{item.leaveType || selectedLeaveType || "-"}</TableCell>
                  {selectedLeaveType ? (
                    <>
                      <TableCell sx={styles.tabledata}>{item.accruedBalance ?? "-"}</TableCell>
                      <TableCell sx={styles.tabledata}>{item.used ?? "-"}</TableCell>
                      <TableCell sx={styles.tabledata}>
                        <Typography sx={{ color: "#28AA4A", fontWeight: "500" }}>
                          {item.balance ?? "-"}
                        </Typography>
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell sx={styles.tabledata}>
                        {item.leaveFrom ?? "-"}
                      </TableCell>
                      <TableCell sx={styles.tabledata}>
                        {item.leaveTo ?? "-"}
                      </TableCell>
                      <TableCell sx={styles.tabledata}>
                        <Chip
                          label={item.status || "-"}
                          size="small"
                          sx={{
                            fontWeight: 500,
                            textTransform: "capitalize",
                            ...getStatusChipStyles(item.status)
                          }}
                        />
                      </TableCell>
                      <TableCell sx={styles.tabledata}>{item.noOfDays ?? "-"}</TableCell>
                    </>
                  )}
                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
                      <IconButton
                        sx={{
                          backgroundColor: "#E5F6FF",
                          borderRadius: "8px",
                          width: "30px",
                          height: "30px",
                          "&:hover": {
                            backgroundColor: "#CCE9FF",
                          },
                        }}
                        onClick={() => handleManage && handleManage(item)}
                        size="small"
                      >
                        <SettingsIcon sx={{ fontSize: "18px", color: "#00ABF4" }} />
                      </IconButton>
                      {canEdit && (
                        <>
                         <IconButton
                          sx={styles.editButton}
                          onClick={() => handleEdit(item)}
                          disabled={!canEdit}
                          size="small"
                        >
                          <EditIcon />
                        </IconButton>
                          <IconButton
                            sx={{
                              backgroundColor: "#FFE5E5",
                              borderRadius: "8px",
                              width: "30px",
                              height: "30px",
                              "&:hover": {
                                backgroundColor: "#FFCCCC",
                              },
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete && handleDelete(item._id || item.id);
                            }}
                            size="small"
                          >
                            <DeleteOutlineIcon sx={{ fontSize: "18px", color: "#FF0000" }} />
                          </IconButton>
                        </>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        {balanceData && balanceData.length > 0 && (
          <CustomPagination
            pageCount={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={balanceData.length}
          />
        )}
      </TableContainer>
    </>
  );
};

export default LeaveBalanceList;

